import idRe from '../lib/id'
import { checkReserved, getWs } from '../lib'

const typeRe = /(?:class|function\s*\*?|async +function)/

/*
- export default class MyNewClass {}
- export default function helloWorld() {}
- export default async function helloWorld() {}
*/

/** @type {_restream.Rule} */
const detectDefault = {
  re: new RegExp(
    `^( *export\\s+default\\s+?)( *${typeRe.source}\\s+(${idRe.source}))`, 'm',
  ),
  replacement,
}

/**
 * @suppress {globalThis}
 * @type {_alamode.ÀLaModeReplacer}
 */
function replacement(match, exportSeg, whatSeg, name) {
  const n = name.trim()
  checkReserved(n)
  this.emit('export', { 'default': n })
  if (this.noSourceMaps) return whatSeg
  const ws = getWs(exportSeg, false)
  return `${ws}${whatSeg}`
}

export default detectDefault

/**
 * @suppress {nonStandardJsDocs}
 * @typedef {import('restream').Rule} _restream.Rule
 */
/**
 * @suppress {nonStandardJsDocs}
 * @typedef {import('alamode/types').ÀLaModeReplacer} _alamode.ÀLaModeReplacer
 */